import { Col, Row } from "@/utils/bootstrap";
import SvgRadioCheckbox from "./SvgRadioCheckbox";

interface Props {
  selected: boolean;
  toggleOption: () => void;
  is_multi_select: boolean;
  label: React.ReactNode;
  disabled?: boolean;
  optionRef?: any;
  value?: any;
  disabledAndChecked?: boolean;
  alloweSelectOutOfStock?: boolean;
}

const BaseOption: React.FC<Props> = ({
  selected,
  toggleOption,
  is_multi_select,
  label,
  disabled = false,
  optionRef,
  value,
  disabledAndChecked,
  alloweSelectOutOfStock,
}) => {
  return (
    <Row
      className="m-0"
      onClick={
        selected
          ? toggleOption
          : !disabled || alloweSelectOutOfStock
          ? toggleOption
          : undefined
      }
      style={{
        gap: 6,
        cursor: !selected && disabled ? "not-allowed" : "pointer",
      }}
    >
      <Col className="p-0 col-auto  mt-1">
        <input
          type="radio"
          className="radioButton-input"
          value={value}
          ref={optionRef}
          checked={selected}
          onChange={
            selected
              ? toggleOption
              : !disabled || alloweSelectOutOfStock
              ? toggleOption
              : undefined
          }
        />
        <SvgRadioCheckbox
          is_multi_select={is_multi_select}
          checked={selected}
          checkedAndDisabled={disabledAndChecked}
        />
      </Col>
      <Col className="p-0 text-wrap">{label}</Col>
    </Row>
  );
};

export default BaseOption;
